import { Box, BoxProps, Flex, VStack, FlexProps, StackProps } from '@chakra-ui/react';
import { ThemeContext } from 'contexts/themeContext';
import { PageSubtitle } from 'components/common/PageSubtitle';
import { PageTitle } from 'components/common/PageTitle';

type AssetManagerPageProps = FlexProps & {
  title: string;
  children: React.ReactNode;
  bodyProps?: BoxProps;
  containerProps?: StackProps;
};

const AssetManagerPage = ({ title, children, bodyProps, containerProps, ...props }: AssetManagerPageProps) => (
  <ThemeContext.Consumer>
    {(theme) => {
      const renderCompanyName = theme?.companyName ? (
        <Box px={4}>
          <PageSubtitle>{theme.companyName}</PageSubtitle>
        </Box>
      ) : null;

      return (
        <Flex
          pt={12}
          w="full"
          bg="linear-gradient(0deg,rgba(238, 238, 238, 1) 1%,rgba(255, 255, 255, 1) 29%,rgba(255, 255, 255, 1) 100)"
          {...props}
        >
          <VStack w="full" {...containerProps}>
            {renderCompanyName}
            <Box pb={10} textAlign="center">
              <PageTitle>{title}</PageTitle>
            </Box>
            <Box w="full" pb={10} {...bodyProps}>
              {children}
            </Box>
          </VStack>
        </Flex>
      );
    }}
  </ThemeContext.Consumer>
);

export default AssetManagerPage;
